import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import { DataUpIcon, Share, SupportIcon } from "../../assets/icons";

const Invitation = () => {
  const navigate = useNavigate();
  const shareLink = async () => {
    const link = window.location.origin;
    let usedShare = false;

    if (navigator.share) {
      try {
        await navigator.share({
          title: "DataUp",
          text: "Join the DataUp Family.",
          url: link,
        });
        usedShare = true;
        return;
      } catch (error) {
        // Fall back to copy if share is canceled or fails.
      }
    }

    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(link);
        if (!usedShare) {
          toast.success("Link copied to clipboard.");
        }
        return;
      } catch (error) {
        // Fallback to manual copy below.
      }
    }

    const textarea = document.createElement("textarea");
    textarea.value = link;
    textarea.setAttribute("readonly", "true");
    textarea.style.position = "absolute";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    if (!usedShare) {
      toast.success("Link copied to clipboard.");
    }
  };

  return (
    <div
      className="relative py-6 px-4 rounded-lg flex flex-col gap-6"
      style={{
        backgroundImage: `url(/images/invitation.jpeg)`,
        backgroundPosition: "center top", // Focus on the top-center part of the image
        backgroundSize: "100% 100%", // Stretch the image height to 200% so the top 50% is visible
        backgroundRepeat: "no-repeat",
      }}
    >
      <img
        src="/png/IVCartoon.png"
        alt=""
        className="absolute -top-4 -right-2 size-24 bp:size-32 bp:-top-8 bp:-right-3 transform scale-x-[-1] z-0"
      />
      <div className="flex flex-col gap-4">
        <DataUpIcon />
        <span className="lt-xl-medium-white z-10 max-w-[70%] bp:max-w-[80%]">
          Invite your friends and family to join the DataUp Family
        </span>
      </div>

      <div className="flex flex-col sm:flex-row gap-3 z-10">
        <button
          className="flex flex-1 items-center justify-center gap-2 h-11 rounded-lg px-4 bg-white hover:bg-opacity-90 transition-all shadow-sm"
          onClick={shareLink}
          type="button"
        >
          <span className="satoshi-sm-bold-toggleBG-dark">Share Link</span>
          <Share />
        </button>

        <button
          className="flex flex-1 items-center justify-center gap-2 h-11 rounded-lg px-4 bg-white/20 backdrop-blur-md border border-white/30 hover:bg-white/30 transition-all shadow-sm"
          onClick={() => navigate("/support")}
          type="button"
        >
          <span className="satoshi-sm-bold-white">Contact Support</span>
          <SupportIcon />
        </button>
      </div>
    </div>
  );
};

export default Invitation;
